// File Metadata:
// Filename: MainContent.jsx
// Version: 1.00
// Created: 2025-03-19 23:09:16
// Last Modified: 2025-04-06 00:56:19
// Authors: Dieuwer Descheemaecker// Description: A brief summary of what this file does

// File Metadata:
// Filename: MainContent.jsx
// Version: 2.00
// Created: 2025-03-19 23:09:16
// Last Modified: 2026-03-01
// Authors: Dieuwer Descheemaecker, GitHub Copilot
// Description: Main content area with sidebar offset

import { Box } from '@mui/material';

const MainContent = ({ children }) => (
  <Box
    id="main-content"
    component="main"
    role="main"
    sx={{
      flexGrow: 1,
      pt: { xs: '56px', sm: '64px' },
      ml: { xs: 0, md: '248px' },
      minHeight: '100vh',
      boxSizing: 'border-box',
    }}
  >
    {children}
  </Box>
);

export default MainContent;